import { Button, Group, Space, Stack } from "@mantine/core";
import { Title } from "../ui/Title";
import { useActivePlaylist } from "@/store/selectors/playlistSelectors";
import { PlaylistScale } from "./PlaylistScale";
import { Text } from "../ui/Text";
import { ListOfRecommendedPlaylists } from "./RecommendPlaylists";
import { useStyles } from "@/styles/useStyles";
import {
  useActiveAssignment,
  useShowAssignmentHeader,
} from "@/store/selectors/assignmentSelectors";
import { Navigation } from "@/services/Navigation";
import { useState } from "react";
import { PlaylistFeedbackModal } from "./PlaylistFeedbackModal";

export const PlaylistConclusion = () => {
  const activePlaylist = useActivePlaylist();
  const activeAssignment = useActiveAssignment();
  const { theme } = useStyles();
  const showAssignmentHeader = useShowAssignmentHeader();
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [playlistRating, setPlaylistRating] = useState(0);

  return (
    <Stack gap="xs" align="center">
      {activePlaylist?.id && (
        <>
          <Title
            order={1}
            size="h1"
            c="text.9"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            You completed the playlist 🎉
          </Title>

          <Space h="md" />

          <Stack
            bg="background.0"
            gap="xs"
            py="xl"
            px="xl"
            style={{
              borderRadius: 6,
              border: `1px solid ${theme.colors.border[3]}`,
            }}
            w="100%"
            align="center"
          >
            <Text
              size="lg"
              c="text.7"
              fw={500}
              maw={400}
              ta="center"
              w="100%"
              lh={1.2}
            >
              What did you think of...
            </Text>

            <Text
              size="xl"
              c="text.9"
              fw={700}
              maw={500}
              ta="center"
              w="100%"
              lh={1.2}
            >
              {activePlaylist?.title}?
            </Text>

            <Space h="xs" />

            <Group justify="center">
              <PlaylistScale
                id="playlist-rating"
                playlistId={activePlaylist?.id}
                lowerText="Not helpful"
                upperText="Super helpful"
                shouldShowFaceIcons
                onSelect={(value) => {
                  setPlaylistRating(value);
                  if (value < 4) {
                    setIsFeedbackModalOpen(true);
                  }
                  // setIsFeedbackModalOpen(true);
                }}
              />
            </Group>
          </Stack>

          <PlaylistFeedbackModal
            opened={isFeedbackModalOpen}
            onClose={() => setIsFeedbackModalOpen(false)}
            rating={playlistRating}
            playlistId={activePlaylist?.id}
          />

          {showAssignmentHeader ? (
            <>
              <Space h="md" />
              <Button
                radius="xl"
                size="lg"
                variant="light"
                color="primary"
                onClick={() => {
                  Navigation.navigate(`/assignments/${activeAssignment?.id}`);
                }}
              >
                Back to Assignment
              </Button>
            </>
          ) : (
            <Space h="xl" />
          )}

          <Space h="xl" />

          <ListOfRecommendedPlaylists />
        </>
      )}

      <Space h="xl" />
    </Stack>
  );
};
